import { Config } from "@/common/Config"

export class ApiClient {
  private static instance: ApiClient

  private constructor() { }

  public static getInstance(): ApiClient {
    if (!ApiClient.instance) {
      ApiClient.instance = new ApiClient()
    }

    return ApiClient.instance
  }

  public async get<T>(path: string, revalidateTime?: number): Promise<T> {
    try {
      const response = await fetch(`${Config.API_URL}${path}`, {
        method: 'GET',
        next: {
          /**  
           * Revalidate based on the provided time or default to 60 seconds.
           * This stores in cache the GET response from the server,
           * and avoid any further requests until the specified time is reached.
           **/
          revalidate: revalidateTime ?? 60
        },
        headers: {
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching data from ${path}:`, error);
      throw error;
    }
  }

  public async post<T>(path: string, body: any): Promise<T> {
    try {
      const isFormData = body instanceof FormData;
      const response = await fetch(`${Config.API_URL}${path}`, {
        method: 'POST',
        body: isFormData ? body : JSON.stringify(body),
        headers: isFormData ? {} : {
          "Content-Type": "application/json",
          'Accept': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error posting data to ${path}:`, error);
      throw error;
    }
  }
}